import _sfc_main from './HoistComponent.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

const _sfc_render = null;
const _sfc_staticRenderFns = null;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/hoist-component/HoistComponent.vue";
var HoistComponent = __component__.exports;

export { HoistComponent as default };
